import * as FileSaver from "file-saver"
import React, { useRef } from 'react'
import Fade from 'react-reveal/Fade'
import * as XLSX from "xlsx"
// import TariffCancelValueForm from '../../components/TariffCancelValue/TariffCancelValueForm/TariffCancelValueForm'
import TariffCancelValueForm from "../../components/TariffCancelValue/TariffCancelValueForm/TariffCancelValueForm"
import Button from '../../components/UI/Button/Button'
import Input from '../../components/UI/Input/Input'
import Search from '../../components/UI/Search/Search'
import Table from "../../components/UI/Table/Table"
import Modal from "../../components/UI/Modal/Modal"
import FetchData from '../../shared/fetchData'
import { updateObject } from '../../shared/utility'
import './TariffCancelValues.css'
import Spinner from "../../components/UI/Spinner/Spinner"
import { Collapse } from "@mui/material"

const TariffCancelValues = (props) => {

    const [loading, setLoading] = React.useState(false)
    const [showBatchForm, setShowBatchForm] = React.useState(false)
    const [rerender, setRerender] = React.useState(false)
    const [pageSize, setPageSize] = React.useState(10)
    const [pageIndex, setPageIndex] = React.useState(0)
    const [pageCount, setPageCount] = React.useState(0)
    const [tableData, setTableData] = React.useState([])
    const [permission, setPermission] = React.useState(window.localStorage.getItem("permission"))
    const [tariffCancelValues, setTariffCancelValues] = React.useState([])
    const [newTariffCancelValuePage, setNewTariffCancelValuePage] = React.useState(false)
    const [changeForm, setChangeForm] = React.useState(false)
    const [edit, setEdit] = React.useState(false)
    const [tariffCancelValue, setTariffCancelValue] = React.useState('')
    const [tariffs, setTariffs] = React.useState([])
    const [tariffId, setTariffId] = React.useState('')
    const [tariffCancelValueId, setTariffCancelValueId] = React.useState('')
    const [shifts, setShifts] = React.useState([])
    const [showDetails, setShowDetails] = React.useState(false)
    const [modalContent, setModalContent] = React.useState('')
    const [searchParams, setSearchParams] = React.useState({
        description: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'نام'
            },
            validation: {
                required: true
            },
            errorMessage: '',
            valid: true,
            cancel: ''
        }
    })
    const ref = useRef();

    React.useEffect(() => {
        setPageIndex(0)
        setPageSize(10)
        setPageCount(0)
        var raw = JSON.stringify({
            "shift": {
            },
            "version": "mtpx001"
        })
        var url = 'management/api/v1/shifts/getShifts'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                setLoading(false)
                if (result.status == 0) {
                    setShifts(result.shifts)
                }
            })
            .catch(error => setLoading(false))

        var raw = JSON.stringify({
            "zone": {
            },
            "version": "mtpx001"
        })
    }, [])

    const inputChangedHandler = (event, controlName) => {
        const updatedControls = updateObject(searchParams, {
            [controlName]: updateObject(searchParams[controlName], {
                value: event.target.value
            })
        });
        setSearchParams(updatedControls)
    }

    const getData = (pagination, isRefresh) => {
        setPageIndex(pagination.pageIndex)
        setPageSize(pagination.pageSize)
        setLoading(true);
        var raw = !!isRefresh && isRefresh ? JSON.stringify({
            "pl": pagination.pageSize,
            "pn": pagination.pageIndex + 1,
            "version": "mtpx001"
        }) : JSON.stringify({
            "tariff": {
                "description": searchParams.description.value
            },
            "pl": pagination.pageSize,
            "pn": pagination.pageIndex + 1,
            "version": "mtpx001"
        })
        var url = 'management/api/v1/tariffs/getTariffs'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                if (result.status == 0) {
                    let newList = []
                    for (let i = 0; i < (pagination.pageIndex * pagination.pageSize); i++) {
                        newList.push([]);
                    }
                    newList = newList.concat(result.tariffs)
                    pushData(newList)
                    setTariffs(newList)
                    setPageCount(result.count)
                    setLoading(false);
                } else {
                    setLoading(false)
                }
            })
            .catch(error => setLoading(false))
    }
    const pushData = (data) => {
        const rows = [];
        const headers = [
            {
                accessorKey: 'description',
                header: "شرح",
                align: 'center',
            },
            {
                accessorKey: 'cancelPenaltyPercent',
                header: "درصد کسر مبلغ",
                align: 'center',
            },
            {
                accessorKey: 'fromDate',
                header: "از تاریخ",
                align: 'center',
            },
            {
                accessorKey: 'toDate',
                header: "تا تاریخ",
                align: 'center',
            },
            {
                accessorKey: 'finalize',
                header: "وضعیت رکورد",
                align: 'center',
            },
            {
                accessorKey: 'isActive',
                header: "وضعیت",
                align: 'center',
            },
        ];
        const buttons = [];
        buttons.push({ id: 1, text: 'مشاهده مقادیر', clicked: showTariffCancelValues });
        buttons.push({ id: 2, text: 'افزودن مقدار', clicked: addTariffCancelValues });
        setTableData({ rows: rows, headers: headers, buttons: buttons });
        data.map(d => {
            rows.push({
                id: d.id,
                description: d.description,
                cancelPenaltyPercent: d.cancelPenaltyPercent,
                fromDate: d.fromDate,
                toDate: d.toDate,
                finalize: d.finalize != null && d.finalize == '1' ? 'نهایی است' : 'نهایی نیست',
                isActive: d.isActive != null && d.isActive == '1' ? 'فعال است' : 'فعال نیست',
            });
        })
        setTableData({ rows: rows, headers: headers, buttons: buttons });
        setRerender(!rerender);
    }
    const search = (event) => {
        getData({ pageIndex: pageIndex, pageSize: pageSize })
    }

    const refresh = (event) => {
        const srch = searchParams
        for (let key in srch) {
            srch[key].cancel = ''
        }
        setSearchParams(srch)
        getData({ pageIndex: pageIndex, pageSize: pageSize }, true)
    }

    const toggleNewLockerForm = (event, cancel) => {
        if (cancel == false) {
            search();
        }
        setNewTariffCancelValuePage(cancel)
    }

    const addNewTariffCancelValue = (event, id) => {
        setTariffCancelValue('')
        setEdit(false)
        toggleNewLockerForm(event, true)
    }

    const editTariffCancelValue = (event, id) => {
        const lckrTp = tariffCancelValues.filter(l => l.id == id)
        if (lckrTp != null && lckrTp.length != 0) {
            setTariffCancelValue(lckrTp[0])
            setEdit(true)
            toggleNewLockerForm(event, true)
        }
    }
    const showTariffCancelValues = (id) => {
        setTariffId(id)
        var raw = JSON.stringify({
            "tariffCancelValue": {
                "tariff": {
                    "id": id
                }
            },
            "pl": 1000,
            "pn": 1,
            "version": "mtpx001"
        })
        var url = 'management/api/v1/tariffCancelValues/getTariffCancelValues'
        setLoading(true)
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                setLoading(false)
                if (result.status == 0) {
                    setTariffCancelValues(result.tariffCancelValues)
                    setShowDetails(true)
                }
            })
            .catch(error => setLoading(false))
    }
    const refreshTariffCancelValues = (event) => {
        var raw = JSON.stringify({
            "tariffCancelValue": {
                "tariff": {
                    "id": tariffId
                }
            },
            "pl": 1000,
            "pn": 1,
            "version": "mtpx001"
        })
        var url = 'management/api/v1/tariffCancelValues/getTariffCancelValues'
        setLoading(true)
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                setLoading(false)
                if (result.status == 0) {
                    setTariffCancelValues(result.tariffCancelValues)
                    if (changeForm) {
                        setChangeForm(false)
                    } else {
                        setChangeForm(true)
                    }
                }
            })
            .catch(error => setLoading(false))
        setNewTariffCancelValuePage(false)
    }
    const addTariffCancelValues = (id) => {
        setTariffId(id)
        setTariffCancelValue('')
        setEdit(false)
        toggleNewLockerForm(null, true)
    }
    const editTariffCancelValues = (event, tariffShCancelId) => {
        setTariffCancelValueId(tariffShCancelId)
        setTariffCancelValue('')
        setEdit(true)
        const tShV = tariffCancelValues.filter(t => t.id === tariffShCancelId);
        if (!!tShV && tShV.length > 0) {
            setTariffCancelValue(tShV[0]);
            toggleNewLockerForm(event, true)
        }
    }
    const addBatchTariffCancelValues = (event, tariffId) => {
        setTariffId(tariffId)
        setEdit(false)
        toggleNewLockerForm(event, false)
        setShowBatchForm(true)
    }
    const toggleShowBatchForm = (event, cancel) => {
        setShowBatchForm(cancel)
    }
    const tariffCancelValueChangeState = (event, id) => {
        setTariffCancelValueId(id)
        setModalContent(<div>
            <div className='row justify-content-center'>
                آیا از تغییر وضعیت مطمئن هستید؟
            </div>
            <div className='row justify-content-center mt-4'>
                <Button btnType='Success' clicked={() => tariffShiftValueChangeStateSubmit(id)}>بله</Button>
            </div>
        </div>)
        ref.current.openModal()
    }
    const tariffShiftValueChangeStateSubmit = (id) => {
        setLoading(true);
        var raw = JSON.stringify({
            "tariffCancelValue": {
                "id": id
            },
            "version": "mtpx001"
        })
        var url = 'management/api/v1/tariffCancelValues/changeTariffCancelValueState'
        setLoading(true)
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                setLoading(false)
                if (result.status == 0) {
                    showTariffCancelValues(tariffId)
                    setLoading(false);
                    ref.current.closeModal()
                    if (changeForm) {
                        setChangeForm(false)
                    } else {
                        setChangeForm(true)
                    }
                }
            })
            .catch(error => setLoading(false))
    }

    const excelTariffCancelValues = (event, tariffId) => {
        var raw = JSON.stringify({
            "tariffCancelValue": {
                "tariff": {
                    "id": tariffId
                }
            },
            "pl": 1000,
            "pn": 1,
            "version": "mtpx001"
        })
        var url = 'management/api/v1/tariffCancelValues/getTariffCancelValues'
        setLoading(true)
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                setLoading(false)
                if (result.status == 0) {
                    let exportCancels = []
                    const cancels = result.tariffCancelValues.map(v => {
                        if (v.isActive == '1') {
                            exportCancels.push({
                                'مقدار': v.cancel,
                                'شناسه تعرفه': tariffId,
                                'شیفت': v.shift != null ? v.shift.id : '',
                                'zone': v.zone != null ? v.zone.id : '',
                                'zone تاریخی': v.calendarZone != null ? v.calendarZone.id : '',
                                "نوع باکس": v.lockerType != null ? v.lockerType.id : ''
                            })
                        }
                    })
                    const fileType =
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
                    const fileExtension = ".xlsx";
                    const ws = XLSX.utils.json_to_sheet(exportCancels);
                    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
                    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
                    const data = new Blob([excelBuffer], { type: fileType });
                    FileSaver.saveAs(data, 'Orders' + fileExtension)
                }
            })
            .catch(error => setLoading(false))
    }

    const afterCloseModal = () => { }

    const formElementsArray = [];
    for (let key in searchParams) {
        formElementsArray.push({
            id: key,
            config: searchParams[key]
        })
    }
    let form = formElementsArray.map(formElement => {
        return (
            <Input
                key={formElement.id}
                elementType={formElement.config.elementType}
                elementConfig={formElement.config.elementConfig}
                value={formElement.config.value}
                invalid={!formElement.config.valid}
                shouldValidate={formElement.config.validation}
                placeholder={formElement.config.placeholder}
                errorMessage={formElement.config.errorMessage}
                search={true}
                col="3 mt-2"
                changed={(event) => inputChangedHandler(event, formElement.id)} />
        );
    })
    form = <div>
        <div className="row pl-4" dir="ltr" style={{ height: '0px' }}>
            <Button btnType="Refresh" clicked={refresh}></Button>
        </div>
        <div className="row mt-4">
            {form}
        </div>
        <div className="row text-left" dir="ltr">
            <div className="col-2 hulf-small">
                <Button btnType="search-btn" clicked={search}>جستجو</Button>
            </div>
            {/* <div className="col-10 text-right mt-1 hulf-small">
                <a href={Sample} className="tariff-sample" download>نمونه فایل</a>
            </div> */}
        </div>
    </div>

    return (
        <div>
            {loading ? <Spinner /> : ''}
            <Collapse in={!showDetails}>
                {!showBatchForm && !newTariffCancelValuePage ?
                    <Fade duration={200} left cascade>
                        <div>
                            <Search class="orders-search" form={form} />

                            {rerender ?
                                // <Spinner />
                                <Table hasDetails={false} data={tariffs} pageSize={pageSize} pageIndex={pageIndex} getData={getData} list={tableData} rowCount={pageCount} columnSize={170} loading={loading} />
                                :
                                <Table hasDetails={false} data={tariffs} pageSize={pageSize} pageIndex={pageIndex} getData={getData} list={tableData} rowCount={pageCount} columnSize={170} loading={loading} />
                            }
                        </div>
                    </Fade>
                    :
                    <>
                        {!showBatchForm ?
                            <TariffCancelValueForm shifts={shifts} tariffId={tariffId} edit={edit} tariffCancelValue={edit ? tariffCancelValue : ''} toggleNewLockerForm={toggleNewLockerForm} refreshTariffCancelValues={(event) => refreshTariffCancelValues(event, tariffId)} />
                            : ''}
                    </>
                }
            </Collapse>
            <Collapse in={showDetails}>

                {!showBatchForm && !newTariffCancelValuePage ?
                    <>
                        {showDetails ?
                            <>
                                {!!tariffCancelValues && tariffCancelValues.length > 0 ? tariffCancelValues.map(t => {
                                    return (
                                        <div className="row justify-content-center w-100 mt-2">
                                            <div className={t.isActive == '1' ? "trf-vls-row" : "deactive-trf-vls-row"}>
                                                <div className="row">
                                                    <div className="col-2 hulf-small">
                                                        درصد جریمه کنسلی: {t.cancelPenaltyPercent}
                                                    </div>
                                                    <div className="col-2 hulf-small">
                                                        فاصله زمانی از: {t.distanceFromTime}
                                                    </div>
                                                    <div className="col-2 hulf-small">
                                                        فاصله زمانی تا: {t.distanceToTime}
                                                    </div>
                                                    <div className="col-2 hulf-small">
                                                        وضعیت: {!!t.isActive && t.isActive == '1' ? 'فعال است' : 'فعال نیست'}
                                                    </div>
                                                    <div className="col-2 hulf-small">
                                                        <Button btnType='General' clicked={(event) => tariffCancelValueChangeState(event, t.id)} >تغییر وضعیت</Button>
                                                    </div>
                                                    <div className="col-2 hulf-small">
                                                        <Button btnType='General' clicked={(event) => editTariffCancelValues(event, t.id)} >ویرایش</Button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                                    :
                                    <div className="row justify-content-center w-100 ml-0 mr-0">
                                        <div className="mt-5 p-4" style={{ width: '50%', backgroundColor: 'white', borderRadius: '9px' }}>
                                            <div className="row justify-content-center w-100 ml-0 mr-0">
                                                مقادیری برای این تعرفه ایجاد نشده است
                                            </div>
                                        </div>
                                    </div>
                                }

                                <div className="row justify-content-center w-100 ml-0 mr-0 mt-4">
                                    <div className="col-6" style={{ textAlign: 'center' }}>
                                        <Button btnType='General' clicked={() => setShowDetails(false)} >برگشت</Button>
                                    </div>
                                </div>
                            </>
                            : ''}
                    </>
                    :
                    <div>
                        {!showBatchForm ?
                            <TariffCancelValueForm shifts={shifts} tariffId={tariffId} edit={edit} tariffCancelValue={edit ? tariffCancelValue : ''} toggleNewLockerForm={toggleNewLockerForm} refreshTariffCancelValues={(event) => refreshTariffCancelValues(event, tariffId)} />
                            : ''}
                    </div>
                }
            </Collapse>
            <Modal
                content={modalContent}
                ref={ref}
                closePermission="true"
                closeModal={(event) => afterCloseModal(event)}
            />
            {/* {showBatchForm ?
                <BatchUploadTariffCancelValue showTariffCancelValues={showTariffCancelValues} toggleShowBatchForm={toggleShowBatchForm} tariffId={tariffId} />
                : ''} */}
        </div>
    )
}

export default TariffCancelValues